import * as React from 'react';

export function SvgAddPhoto(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.182 4.818a1 1 0 011-1h3.272a1 1 0 01.833.446l1.34 2.009h2.737A2.636 2.636 0 0122 8.909v9a2.636 2.636 0 01-2.636 2.637H4.636A2.636 2.636 0 012 17.909v-6.545a1 1 0 112 0v6.545a.636.636 0 00.636.637h14.728a.636.636 0 00.636-.637v-9a.636.636 0 00-.636-.636H16.09a1 1 0 01-.832-.445l-1.34-2.01h-2.737a1 1 0 01-1-1z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10.727a2.273 2.273 0 100 4.546 2.273 2.273 0 000-4.546zM7.727 13a4.273 4.273 0 118.546 0 4.273 4.273 0 01-8.546 0zM5.454 3a1 1 0 011 1v4.91a1 1 0 11-2 0V4a1 1 0 011-1z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 6.455a1 1 0 011-1h4.91a1 1 0 110 2H3a1 1 0 01-1-1z"
        fill="currentColor"
      />
    </svg>
  );
}
